export default {"src":"/_next/static/media/chat-bot-avatar-image.eaea25e0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};